import config from "../../config.json";

// Branch preparation (draft branches of the client's own store) and branch users, /branch-preparation/*. Every call returns the server's
// answer or throws a PrepError carrying the server's `code` (LOGIN_EMAIL_TAKEN, CONTACT_EMAIL_TAKEN, SHARED_ACCOUNT, ...).

const BASE = config.BASE_AUTH_API;

export class PrepError extends Error {
  constructor(message, { status = 0, code = null } = {}) {
    super(message);
    this.name = "PrepError";
    this.status = status;
    this.code = code;
  }
}

const request = async (token, endpoint, { method = "GET", body, file } = {}) => {
  let response;
  try {
    const headers = { Accept: "application/json", Authorization: `Bearer ${token}` };
    let payload;
    if (file) {
      payload = new FormData();
      payload.append("file", file);
    } else if (body !== undefined) {
      headers["Content-Type"] = "application/json";
      payload = JSON.stringify(body);
    }
    response = await fetch(`${BASE}branch-preparation/${endpoint}`, { method, headers, body: payload });
  } catch (error) {
    throw new PrepError(error.message || "Network error", { code: "NETWORK" });
  }
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok || !data?.success) {
    throw new PrepError(data?.message || "Request failed", { status: response.status, code: data?.code || null });
  }
  return data;
};

const branch = (storeId, branchId = "") => `stores/${encodeURIComponent(storeId)}/branches${branchId ? `/${encodeURIComponent(branchId)}` : ""}`;

export const createPreparedBranchAPI = async (token, storeId, payload) => (await request(token, branch(storeId), { method: "POST", body: payload })).branch;
export const updatePreparedBranchAPI = async (token, storeId, branchId, payload) => (await request(token, branch(storeId, branchId), { method: "PUT", body: payload })).branch;
export const removePreparedBranchAPI = async (token, storeId, branchId) => request(token, branch(storeId, branchId), { method: "DELETE" });
export const setPreparedBranchHoursAPI = async (token, storeId, branchId, workTime) => (await request(token, `${branch(storeId, branchId)}/work-time`, { method: "PUT", body: { workTime } })).branch;
export const uploadPreparedBranchLicenseAPI = async (token, storeId, branchId, file) => (await request(token, `${branch(storeId, branchId)}/license`, { method: "POST", file })).branch;
export const removePreparedBranchLicenseAPI = async (token, storeId, branchId) => (await request(token, `${branch(storeId, branchId)}/license`, { method: "DELETE" })).branch;

export const listEligibleBranchUsersAPI = async (token, search = "") => (await request(token, `branch-users/eligible${search ? `?search=${encodeURIComponent(search)}` : ""}`)).users;
export const listBranchUsersAPI = async (token, storeId, branchId) => (await request(token, `${branch(storeId, branchId)}/users`)).users;
export const assignBranchUserAPI = async (token, storeId, branchId, userId) => request(token, `${branch(storeId, branchId)}/users`, { method: "POST", body: { userId } });
export const createBranchUserAPI = async (token, storeId, branchId, create) => request(token, `${branch(storeId, branchId)}/users`, { method: "POST", body: { create } });
export const updateBranchUserAPI = async (token, storeId, branchId, userId, payload) => request(token, `${branch(storeId, branchId)}/users/${encodeURIComponent(userId)}`, { method: "PATCH", body: payload });
export const unassignBranchUserAPI = async (token, storeId, branchId, userId) => request(token, `${branch(storeId, branchId)}/users/${encodeURIComponent(userId)}`, { method: "DELETE" });
export const resendBranchUserInvitationAPI = async (token, storeId, branchId, userId) => request(token, `${branch(storeId, branchId)}/users/${encodeURIComponent(userId)}/invitation`, { method: "POST", body: {} });
